import { useParams } from "react-router-dom";
import { SideTabsPage } from "@/components/shared";
import { storeReports } from "@/components/store/reports";

const StoreReports = () => {
  const { reportId } = useParams<{ reportId?: string }>();

  return (
    <SideTabsPage
      title="Reports"
      description="Sales, payments, BV and product reports for your store. Export to Excel or PDF."
      basePath="/store/reports"
      tabs={storeReports}
      tabId={reportId}
    />
  );
};

export default StoreReports;
